import { useCallback, useEffect, useRef } from 'react'
import equal from 'fast-deep-equal'

const useDeepCompareMemoize = value => {
  const ref = useRef()

  if (!equal(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

export function useDeepCompareCallback (callback, dependencies) {
  return useCallback(callback, useDeepCompareMemoize(dependencies))
}

const useDeepCompareEffect = (callback, dependencies) => {
  useEffect(callback, useDeepCompareMemoize(dependencies))
}

export default useDeepCompareEffect
